import axios from 'axios';


export const getTeamGraph = (filterResult: string) => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL+`capacity/team-tab?where=${filterResult}`
  );
};
export const getTradeGraph = (filterResult: string) => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL+`capacity/trade-tab?where=${filterResult}`
  );
};
export const getShiftGraph = (filterResult: string) => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL+`capacity/shift-tab?where=${filterResult}`
  );
};
export const getTradePersonGraph = (filterResult: string) => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL+`capacity/tradeperson-tab?where=${filterResult}`
  );
};
